import { Autocomplete, Box, Button, TextField, Typography } from '@mui/material'
import React, { SyntheticEvent, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { bannerProductFilterMappingObj, bannerTemplateOptionConfigProps, bannerTypeOption } from '../../features/createBanner/bannerTypes';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';
import { useTranslation } from 'react-i18next';
import { bannerProductFilterMapping } from '../createBanner/bannerTemplates';
import CategorySubcategory from '../../components/Input/bannnerInputs/CategorySubcategory';
import ImageInputs from '../../components/Input/bannnerInputs/ImageInputs';
import YoutubeInputs from '../../components/Input/bannnerInputs/YoutubeInputs';
import GoogleInputs from '../../components/Input/bannnerInputs/GoogleInputs';
import CommunicationInputs from '../../components/Input/bannnerInputs/CommunicationInputs';
import CategoryImageInputs from '../../components/Input/bannnerInputs/CategoryImageInputs';
import RedirectToPage from '../../components/Input/bannnerInputs/RedirectToPage';
import ImageWithBasketIdInputs from '../../components/Input/bannnerInputs/ImageWithBasketIdInputs';
import AppSchemeFilter from '../../components/Input/bannnerInputs/AppSchemeFilter';
import YoutubeLinkInputs from '../../components/Input/bannnerInputs/YoutubeLinkInputs';
import { getPriorityLabel } from '../manageCoupons/components/CreateBanner/service';
import { BannerContext } from '../createBanner/BannerContext';
import { getConfigFromClientConfig } from '../../services/bannerServices';
import { getMetaDataConfig, getNewConfiguration } from '../../services/uiConfigService';

const defaultBannerOption = { id: "", label: "" } as bannerTypeOption;
function BannerTemplateOptionConfigNew(props: any) {
    const [maxImageSize, setMaxImageSize] = useState<number | undefined>(undefined);
    const [maxGifSize, setMaxGifSize] = useState<number | undefined>(undefined);
    const [maxSelection, setMaxSelection] = useState<number | undefined>(undefined);
    useEffect(() => {
      async function fetchMaxImageSize() {
        try {
          const bannerConfig = await getNewConfiguration('banner_configuration');
          const bannerConfigValue= bannerConfig && bannerConfig?.domainValues?.[0].value;
          const bannerStatusConfig = bannerConfigValue && bannerConfigValue.find((item: { name: string; }) => item.name === "maxImageSize");
          const bannerGIF = bannerConfigValue && bannerConfigValue.find((item: { name: string; }) => item.name === "maxGIFSize");
          const maxSelection = bannerConfigValue && bannerConfigValue.find((item: { name: string; }) => item.name === "maxSelection");
          setMaxImageSize(bannerStatusConfig?.value);
          setMaxGifSize(bannerGIF?.value);
          setMaxSelection(maxSelection?.value)
        } catch (error) {
          console.error("Failed to fetch max image size", error);
        }
      }
      fetchMaxImageSize();
    }, []);
    const bannerConfig = useContext(BannerContext);
    const [showPriority,setShowPriority] = useState(false)
    const [allowedResolutions, setAllowedResolutions] = useState<string[]>(["1024 X 376", "500 X 416"]);
    const clientConfigRef = useRef<any[]>([]);
    const defaultRedirectionToProductList = [
        { label: "Scheme ID", id: "schemeId",mediaName:"imageWithSchemes" },
        { label: "Basket Type", id: "basket",mediaName:"ImageWithBasketId" },
        { label: "Customized Product List", id: "subCat",mediaName:"imageWithProducts" }
    ];
    const [redirectionToProductListOption, setRedirectionToProductListOption] = useState(defaultRedirectionToProductList);
    // 
    console.log("props?.bannerBehaviour?.id ",props?.bannerBehaviour?.id )
    const bannerElementOptions = props?.bannerBehaviour?.id 
    ? props?.bannerBehaviour?.id === "tvAdds" ? [
        { label: "Redirection To Product List", id: "redirectionToProductList",mediaName:"redirectionToProduct" }, 
        { label: "Redirection Via Links", id: "redirectionFromLinks",mediaName:"redirectionFromLinks" },
    ] : [
        { label: "Image", id: "image" ,mediaName:"image"}, 
        { label: "Redirection To Product List", id: "redirectionToProductList",mediaName:"redirectionToProduct" }, 
        { label: "Redirection Via Links", id: "redirectionFromLinks",mediaName:"redirectionFromLinks" },
        { label: "Redirection To App Pages", id: "redirectionToAppPages" ,mediaName:"redirectToPage"}
    ]
    : [];

    const redirectionToProductList = props?.bannerBehaviour?.id === "tvAdds" ? [
        { label: "Customized Product List", id: "subCat",mediaName:"youtubeLinkWithProducts" }
    ] :redirectionToProductListOption;

    const redirectionFromLinksOption = props?.bannerBehaviour?.id === "tvAdds" ? [
        { label: "YouTube URL", id: "youtube",mediaName:"youtubeLink" }
    ] :[
        { label: "URL", id: "google",mediaName:"google" },
        { label: "YouTube URL", id: "youtube",mediaName:"youtube" }
    ];
    const mediaNameMapping = [
        {  element: "image",mediaName:"image" },
        { element: "redirectionToProductList",mediaName:"ImageWithBasketId" },
        { element: "redirectionToProductList",mediaName:"imageWithSchemes" },
        { element: "redirectionToProductList",mediaName:"imageWithProducts" },
        {  element: "redirectionFromLinks",mediaName:"google" },
        { element: "redirectionFromLinks",mediaName:"youtube" },
        { element: "redirectionFromLinks",mediaName:"youtubeLink" },
        { element: "redirectionToProductList",mediaName:"youtubeLinkWithProducts" },
        { element: "redirectionToAppPages",mediaName:"redirectToPage" }
    ];
    const defaultRedirectionToAppPagesOption = [
        { label: "All Catalogue", id: "allCatalogue" },
        { label: "Order Tracking", id: "orderTracking" },
        { label: "FAQ", id: "faqScreen" },
        { label: "Consumer Promo", id: "consumerPromo" },
        { label: "Language", id: "LanguageScreen" },
        { label: "Notification", id: "Notifications" },
        { label: "Offers", id: "offers" },
        { label: "Order Tracking", id: "orderTracking" },
        { label: "Privacy", id: "privacyLink" },
        { label: "Reward", id: "rewards" },
        { label: "Terms and Condition", id: "tncLink" },
        { label: "Support", id: "helpdesk" },
        { label: "One Click Page", id: "oneClick" },
        {
        id: "outletScreen-dbVisit",
        label: "Outlet Screen"
    }
    ]
    const [redirectionToAppPagesOption, setRedirectionToAppPagesOption] = useState(defaultRedirectionToAppPagesOption);

    const [selectedElementOption, setElementSelectedOption] = useState<any | null>(null);
    const [selectedSubOption, setSelectedSubOption] = useState<any | null>(null);
    const [selectedFinalOption, setSelectedFinalOption] = useState<any | null>(null);
    console.log("props.elementState",props.elementState)

    const handleBannerTemplateOptions = (event: any, newValue: any) => {
        setElementSelectedOption(newValue);
        setSelectedSubOption(null);
        setSelectedFinalOption(null); 
        props.setLanguageBannerState((prevLanguageBannerState:any) => {
            const newLanguageBannerState = {...prevLanguageBannerState};
            newLanguageBannerState[props.languageCode][props.elemNumber] = {mediaName: newValue.mediaName};
            return newLanguageBannerState;
          });
    };

    const handleSubOptionChange = (event: any, newValue: any) => {
        
        setSelectedSubOption(newValue);
        if(newValue && newValue?.mediaName) props.setLanguageBannerState((prevLanguageBannerState:any) => {
            const newLanguageBannerState = {...prevLanguageBannerState};
            const curElementState = newLanguageBannerState[props.languageCode][props.elemNumber];
            newLanguageBannerState[props.languageCode][props.elemNumber] = {...curElementState, mediaName: newValue?.mediaName}
            return newLanguageBannerState
          });
        setSelectedFinalOption(null);
    };
    const handlePagesOptionChange = (event: any, newValue: any) => {
        setSelectedSubOption(newValue);
        props.setLanguageBannerState((prevLanguageBannerState:any) => {
            
            const newLanguageBannerState = {...prevLanguageBannerState};
            const curElementState = newLanguageBannerState[props.languageCode][props.elemNumber];
            const curElementComponentState = newLanguageBannerState[props.languageCode][props.elemNumber].elementComponents;
            newLanguageBannerState[props.languageCode][props.elemNumber] = {...curElementState, mediaName: "redirectToPage",redirection:newValue.id}
            return newLanguageBannerState
          });
        setSelectedFinalOption(null);
    };

    const handleFinalOptionChange = (event: any, newValue: any) => {
        setSelectedFinalOption(newValue);
        if(newValue && selectedSubOption?.id==="basket") props.setLanguageBannerState((prevLanguageBannerState:any) => {
            const newLanguageBannerState = {...prevLanguageBannerState};
            const curElementState = newLanguageBannerState[props.languageCode][props.elemNumber];
            newLanguageBannerState[props.languageCode][props.elemNumber] = {...curElementState, [selectedSubOption?.id]: newValue}
            return newLanguageBannerState
          });
    };

  const {translate} = usePortalTranslation();

  const [productFilterResetCounter,setProductFilterResetCounter] = useState<number>(0);
//   const handleBannerTemplateOptions = (event:SyntheticEvent, value: bannerTypeOption) => {
//     if(value){
//       if(props.bannerTemplateType?.catSubCatReq){
//         let catSubCatStates = {};
//         bannerProductFilterMapping.forEach((productFilter: bannerProductFilterMappingObj) => {
//           if(props.elementState[productFilter.id]) catSubCatStates = {...catSubCatStates,[productFilter.id]: props.elementState[productFilter.id]}
//         })
//         props.setLanguageBannerState((prevLanguageBannerState:any) => {
//           const newLanguageBannerState = {...prevLanguageBannerState};
//           newLanguageBannerState[props.languageCode][props.elemNumber] = {...catSubCatStates,mediaName: value.id};
//           return newLanguageBannerState;
//         });
//       }else{
        // props.setLanguageBannerState((prevLanguageBannerState:any) => {
        //   const newLanguageBannerState = {...prevLanguageBannerState};
        //   newLanguageBannerState[props.languageCode][props.elemNumber] = {mediaName: value.id};
        //   return newLanguageBannerState;
        // });
//       }
//     }   
//   }
  function handleReset(){
    props.setLanguageBannerState((prevLanguageBannerState:any) => {
      const newLanguageBannerState = {...prevLanguageBannerState};
      newLanguageBannerState[props.languageCode][props.elemNumber] = {};
      return newLanguageBannerState;
    });
    setElementSelectedOption(null)
    setSelectedSubOption(null)
    setSelectedFinalOption(null)
    setProductFilterResetCounter(productFilterResetCounter+1);
  }
  const showResetButton = props.elementState.mediaName || (bannerProductFilterMapping.some((productFilter: bannerProductFilterMappingObj) => {
    return props.elementState[productFilter.id] && props.elementState[productFilter.id]?.length!==0;
  }))
  const selectedBannerType = useMemo(() => {
      
      const matchingElement = mediaNameMapping?.find(mapping => mapping.mediaName === props.elementState.mediaName);
      let matchingBannerOption = null;
      if (matchingElement) {
          matchingBannerOption = bannerElementOptions?.find(option => option.id === matchingElement.element);
      }
      if(matchingBannerOption){
        setElementSelectedOption(matchingBannerOption)
    //   if(matchingBannerOption.id==="redirectionToProductList" || matchingBannerOption.id==="redirectionFromLinks" || matchingBannerOption.id==="redirectionToAppPages"){
    //   }
        if(matchingBannerOption.id==="redirectionToProductList"){
            let matchingBannerSubOption = redirectionToProductList?.find(option => option.mediaName === props.elementState.mediaName);
            setSelectedSubOption(matchingBannerSubOption)
            if(props.elementState.basket){
                setSelectedFinalOption(props.elementState.basket)
            }
        }
        if(matchingBannerOption.id==="redirectionFromLinks"){
            let matchingBannerSubOption = redirectionFromLinksOption?.find(option => option.mediaName === props.elementState.mediaName);
            setSelectedSubOption(matchingBannerSubOption)
        }
        if(matchingBannerOption.id==="redirectionToAppPages"){
            console.log("props.elementState",props.elementState)
            
            let matchingBannerSubOption = redirectionToAppPagesOption?.find(option => option.id === props.elementState.redirection);
            setSelectedSubOption(matchingBannerSubOption)
        }
      }
      return matchingBannerOption
  },[props.elementState.mediaName])
  console.log("props,selectedBannerType",selectedBannerType,selectedElementOption,selectedSubOption,selectedSubOption)
  useEffect(() => {
    async function getBannerBehaviourOption(){
        if(!clientConfigRef.current || clientConfigRef.current.length<=0){
            const clientConfig = await getMetaDataConfig("clientconfig");
            clientConfigRef.current = clientConfig;
        }
        const bannerConfig= getConfigFromClientConfig(clientConfigRef.current,"banner_configuration")?.[0]?.value;
        
        const productListOptions = bannerConfig?.find((option: {name: string}) => {
            return option.name === "productListOptions"
        })
        if(productListOptions && productListOptions.value && productListOptions.value.length>0 ){
            setRedirectionToProductListOption(productListOptions.value)
        }
    }
    getBannerBehaviourOption();
 }, [props?.bannerBehaviour?.id]);
 useEffect(() => {
    async function getPageTypeOption(){
        if(!clientConfigRef.current || clientConfigRef.current.length<=0){
            const clientConfig = await getMetaDataConfig("clientconfig");
            clientConfigRef.current = clientConfig;
        }
        const bannerConfig= getConfigFromClientConfig(clientConfigRef.current,"banner_configuration")?.[0]?.value;
        
        const pageTypeOptions = bannerConfig?.find((option: {name: string}) => {
            return option.name === "pageTypeOptions"
        })
        const showPriority = bannerConfig?.find((option: {name: string}) => {
            return option.name === "showPriority"
        })?.value;
        if(pageTypeOptions && pageTypeOptions.value && pageTypeOptions.value.length>0){
            setRedirectionToAppPagesOption(pageTypeOptions.value)
        }
        const showPriorityResolution = bannerConfig?.find((option: {name: string}) => {
            return option.name === "showPriorityResolution"
        })?.value;
        if(showPriorityResolution && showPriorityResolution.length>0){
            setAllowedResolutions(showPriorityResolution)
        }
        
        if(showPriority){
            setShowPriority(true)
        }
    }
    getPageTypeOption();
 }, []);
  useEffect(() => {
   if(!props.isEdit){
    setElementSelectedOption(null)
   }
}, [props?.bannerBehaviour?.id]);
const priorityOptions = useMemo(() => Array.from({ length: 20 }, (_, i) => i + 1).map((number) => (
    number + ""
)),[]);
const handlePriorityChange = (event: SyntheticEvent, value: string) => {
    props.setLanguageBannerState((prevLanguageBannerState:any) => {
      const newLanguageBannerState = {...prevLanguageBannerState};
      const curElementState = newLanguageBannerState[props.languageCode][props.elemNumber];
      newLanguageBannerState[props.languageCode][props.elemNumber] = {...curElementState, bannerPriority: value };
      return newLanguageBannerState;
    });
  }
  return (
    <Box className="bannerElementBoxContainer">
    <div className='bannerDescriptionAndElementHeadingContainer'><Typography className='bannerElementAndDescriptionHeading' variant="h6" pl={2} > {translate(TranslationEnum.manage_banner,"Element")} {props.elemNumber + 1}</Typography> </div>
          <Autocomplete
              disableClearable
              disablePortal
              className="bannerTypeAutoSelect createBannerInputsMargin"
              value={selectedElementOption?.label || ''}
              id="elementType"
              options={bannerElementOptions}
              onChange={handleBannerTemplateOptions}
              renderInput={(params) => (
                  <TextField {...params} label={translate(TranslationEnum.manage_banner, "Select Banner Behaviour")} />
              )}
          />
          {selectedElementOption?.id === 'image' && (
              <ImageInputs maxImageSize={maxImageSize} maxGifSize={maxGifSize} key={props.elementState.mediaName} languageCode={props.languageCode} elemNumber={props.elemNumber} elementState={props.elementState} resolution={props.bannerResolutionType?.resolution} setLanguageBannerState={props.setLanguageBannerState} checkErrors={props.checkErrors} />
          )}
          {selectedElementOption?.id === 'redirectionToProductList' && (
              <Box mt={2}>
                  <Autocomplete
                      className="bannerTypeAutoSelect createBannerInputsMargin"
                      disableClearable
                      disablePortal
                      value={selectedSubOption?.label || ''}
                      id="subOptionType"
                      options={redirectionToProductList}
                      onChange={handleSubOptionChange}
                      renderInput={(params) => (
                          <TextField {...params} label="Select Product List" />
                      )}
                  />
                  {selectedSubOption?.id === 'schemeId' && (
                      <>
                          <AppSchemeFilter languageCode={props.languageCode} elemNumber={props.elemNumber} elementState={props.elementState} setLanguageBannerState = {props.setLanguageBannerState} categories={props.categories} checkErrors={props.checkErrors} productFilterResetCounter={productFilterResetCounter} />
                          <ImageInputs maxImageSize={maxImageSize} maxGifSize={maxGifSize} key={props.elementState.mediaName} languageCode={props.languageCode} elemNumber={props.elemNumber} elementState={props.elementState} resolution={props.bannerResolutionType?.resolution} setLanguageBannerState={props.setLanguageBannerState} checkErrors={props.checkErrors} />
                      </>
                  )}
                  {selectedSubOption?.id === 'basket' && (
                      <>
                          <Autocomplete
                          className="bannerTypeAutoSelect createBannerInputsMargin"
                              disableClearable
                              disablePortal
                              value={selectedFinalOption || ''}
                              id="basket"
                              options={props.baskets}
                              onChange={handleFinalOptionChange}
                              renderInput={(params) => (
                                  <TextField {...params} label="Select Basket Type" />
                              )}
                          />
                          <ImageInputs maxImageSize={maxImageSize} maxGifSize={maxGifSize} key={props.elementState.mediaName} languageCode={props.languageCode} elemNumber={props.elemNumber} elementState={props.elementState} resolution={props.bannerResolutionType?.resolution} setLanguageBannerState={props.setLanguageBannerState} checkErrors={props.checkErrors} />
                      </>
                  )}
                   {selectedSubOption?.id === 'subCat' && (
                      <>
                           <CategorySubcategory maxSelection={maxSelection} languageCode={props.languageCode} elemNumber={props.elemNumber} elementState={props.elementState} setLanguageBannerState = {props.setLanguageBannerState} categories={props.categories} checkErrors={props.checkErrors} productFilterResetCounter={productFilterResetCounter} />
                          { props?.bannerBehaviour?.id === "tvAdds" ?  <YoutubeLinkInputs key={props.elementState.mediaName} languageCode={props.languageCode} elemNumber={props.elemNumber} elementState={props.elementState} setLanguageBannerState={props.setLanguageBannerState} checkErrors={props.checkErrors} />  : 
                           <ImageInputs maxImageSize={maxImageSize} maxGifSize={maxGifSize} key={props.elementState.mediaName} languageCode={props.languageCode} elemNumber={props.elemNumber} elementState={props.elementState} resolution={props.bannerResolutionType?.resolution} setLanguageBannerState={props.setLanguageBannerState} checkErrors={props.checkErrors} />
                          }
                      </>
                  )}
              </Box>
          )}
            {selectedElementOption?.id === 'redirectionFromLinks' && (
              <Box mt={2}>
                  <Autocomplete
                      className="bannerTypeAutoSelect createBannerInputsMargin"
                      disableClearable
                      disablePortal
                      value={selectedSubOption?.label || ''}
                      id="subOptionType"
                      options={redirectionFromLinksOption}
                      onChange={handleSubOptionChange}
                      renderInput={(params) => (
                          <TextField {...params} label="Select Link Type" />
                      )}
                  />
                  {selectedSubOption?.id === 'google' && (
                      <>
                         <GoogleInputs key={props.elementState.mediaName} languageCode={props.languageCode} elemNumber={props.elemNumber} elementState={props.elementState} resolution={props.bannerResolutionType?.resolution} setLanguageBannerState={props.setLanguageBannerState} checkErrors={props.checkErrors}/>
                      </>
                  )}
                  {selectedSubOption?.id === 'youtube' && (
                      <>
                      {props?.bannerBehaviour?.id === "tvAdds" ?  <YoutubeLinkInputs key={props.elementState.mediaName} languageCode={props.languageCode} elemNumber={props.elemNumber} elementState={props.elementState} setLanguageBannerState={props.setLanguageBannerState} checkErrors={props.checkErrors} /> : 
                          <YoutubeInputs key={props.elementState.mediaName} languageCode={props.languageCode} elemNumber={props.elemNumber} elementState={props.elementState} resolution={props.bannerResolutionType?.resolution} setLanguageBannerState={props.setLanguageBannerState} checkErrors={props.checkErrors}/>
                      }                   
                      </>
                  )}
              </Box>
          )}
           {selectedElementOption?.id === 'redirectionToAppPages' && (
              <Box mt={2}>
                  <Autocomplete
                      className="bannerTypeAutoSelect createBannerInputsMargin"
                      disableClearable
                      disablePortal
                      value={selectedSubOption?.label || ''}
                      id="subOptionType"
                      options={redirectionToAppPagesOption}
                      onChange={handlePagesOptionChange}
                      renderInput={(params) => (
                          <TextField {...params} label="Select Page Type" />
                      )}
                  />
                   <ImageInputs maxImageSize={maxImageSize} maxGifSize={maxGifSize} key={props.elementState.mediaName} languageCode={props.languageCode} elemNumber={props.elemNumber} elementState={props.elementState} resolution={props.bannerResolutionType?.resolution} setLanguageBannerState={props.setLanguageBannerState} checkErrors={props.checkErrors} />
              </Box>
          )}
          {(showPriority && allowedResolutions.includes(props.bannerResolutionType?.label ?? "")) &&  <Autocomplete 
        disableClearable
        disablePortal
        className="bannerTypeAutoSelect createBannerInputsMargin"
        value={props.elementState?.bannerPriority ?? ""}
        id="elementType"
        options={priorityOptions}
        getOptionLabel={((option) => option? option + " - " + getPriorityLabel(parseInt(option)) : "") }
        onChange={handlePriorityChange}
        renderInput={(params) => <TextField {...params}  label="Select Priority" />}
      />}
    {/* {props.bannerTemplateType?.priorityFilter && 
      <Autocomplete 
        disableClearable
        disablePortal
        className="bannerTypeAutoSelect createBannerInputsMargin"
        value={props.elementState?.bannerPriority ?? ""}
        id="elementType"
        options={priorityOptions}
        getOptionLabel={((option) => option? option + " - " + getPriorityLabel(parseInt(option)) : "") }
        onChange={handlePriorityChange}
        renderInput={(params) => <TextField {...params}  label="Select Priority" />}
      />
    }
    {props.bannerTemplateType?.catSubCatReq || props.elementState.mediaName === "Image with Products"?
    <>
      <CategorySubcategory languageCode={props.languageCode} elemNumber={props.elemNumber} elementState={props.elementState} setLanguageBannerState = {props.setLanguageBannerState} categories={props.categories} checkErrors={props.checkErrors} productFilterResetCounter={productFilterResetCounter} />
    </> 
    : <></>} */}
    {/* {loadBannerInputs()} */}
    {showResetButton?<div className='bannerElementResetButtonContainer'>
      <Button
          className='bannerButtonStyles'
          onClick={handleReset}
          variant="contained"
        >
          {translate(TranslationEnum.common_portal,"RESET")}
        </Button>
      </div>: <></>}
</Box>
  )
}

export default BannerTemplateOptionConfigNew   